import { useRef, useState } from "react";
import { GRANT_REQUEST_NOTE_MAX_LENGTH } from "../../shared/grantRequests";
import { Button } from "./Button";
import { Modal } from "./Modal";
import { ModalContent, ModalFooter } from "./ModalCard";
import { NoteInput } from "./NoteInput";
import { Text } from "./Text";

type Props = {
  connectorName: string;
  onClose: () => void;
  onSend: (note: string | undefined) => void;
};

export function RequestShareModal({ connectorName, onClose, onSend }: Props) {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [note, setNote] = useState("");

  return (
    <Modal open onClose={onClose} alert initialFocusRef={inputRef}>
      <ModalContent style={{ width: 360 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Text variant="text-regular-md" color="var(--text-primary)">
            Send share request?
          </Text>
          <Text variant="text-regular" color="var(--text-secondary)">
            An admin will review your request to share {connectorName}. Adding a
            reason helps them understand why it’s needed.
          </Text>
        </div>
        <NoteInput
          inputRef={inputRef}
          label="Request reason"
          hideLabel
          helperText="Optional."
          placeholder="Explain why you’d like to share this connector…"
          maxLength={GRANT_REQUEST_NOTE_MAX_LENGTH}
          value={note}
          onChange={setNote}
        />
        <ModalFooter>
          <Button size="l" variant="subtle" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="l"
            variant="primary"
            onClick={() => onSend(note.trim() || undefined)}
          >
            Send request
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
